import {
  QuickLinks,
  QuickLinksArgs,
  getQuickLinks,
} from '../assets/ts/data/quick-links'
import useServerData from './use-server-data'

function useQuickLinks(fetchArgs, waitOnParentDependency = false) {
  const {
    data: quickLinks,
    error: quickLinksError,
    fetchData: fetchQuickLinks,
    isLoading: quickLinksAreLoading,
  } = useServerData<QuickLinks, QuickLinksArgs>(
    getQuickLinks,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    fetchQuickLinks,
    quickLinks,
    quickLinksAreLoading,
    quickLinksError,
  }
}

export default useQuickLinks
